import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import { queryRechargePackage, createOrder, createStripeOrder } from '@/api/shop';
import { sendSMS } from '@/api/sms.js';
import { getStorageData } from '@/utils/util';
import { report } from '@/api/report';
import { mixins } from '@/mixins';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import Tab from '@/components/Tab/Tab.vue';
import Dialog from '@/components/Dialog/Dialog.vue';
import OpenApp from '@/components/OpenApp/OpenApp.vue';

export default {
	name: 'Recharge',

	mixins: [mixins],

	data() {
		return {
			pageLoading: false,
			dataList: [],
			payType: 'apple',
			tabList: [
				{
					id: 'apple',
					name: 'Apple'
				},
			]
		};
	},

	computed: {
    ...mapGetters(['points', 'inviteCode', 'userToken']),
  },

  methods: {
  	init() {
  		if (localStorage.getItem('debug') === '1') {
  			this.tabList.push({
  				id: 'stripe',
					name: 'Stripe'
  			});
  		}

  		this.renderGoodsList();
  	},

  	async renderGoodsList() {
  		const userToken = this.userToken || '';
  		const payTypeNow = this.payType;
  		const requestPayTypes = {
  			apple: 0,
  			usdt: 1,
  			stars: 2,
  			paddle: 3,
  			stripe: 4
  		};

  		this.dataList = [];
  		this.pageLoading = true;

  		try {
  			const res = await queryRechargePackage({
  				token: userToken,
  				type: requestPayTypes[payTypeNow] || 0
  			});

  			if (payTypeNow !== this.payType) {
  				return;
  			}

  			this.dataList = this.makeRenderList(res.data.list);
  		}
  		catch(err) {}
  		this.pageLoading = false;
  	},

  	onTabChange(params) {
  		this.payType = params.activeId;
  		this.renderGoodsList();
  	},

  	async detail() {
  		const inviteCode = this.inviteCode || '';

			this.$router.push({
        path: `/all_records`,
        query: {
          invite_code: inviteCode,
        }
      });
  	},

  	async buy(item) {
  		report({
	      event_type: 'click',
	      event_value: `click_goods_${item.price}`
	    });

	    if (item.type === 'stripe') {
	    	this.payByStripe(item);
	    	return;
	    }

	    if (item.type === 'apple') {
	    	this.$refs.installAppTips.show();
	    	return;
	    }
  	},

  	async payByStripe(item) {
  		const loading = Loading.service({
	      fullscreen: true,
	      customClass: 'text-loading',
	      text: 'Payment connecting...'
	    });
	    const userToken = this.userToken || '';

	    try {
	    	const res = await createStripeOrder({
	    		token: userToken,
	    		package_id: item.id
	    	});

	    	if (res.code !== 0) {
	    		loading.close();
	    		this.$message({
			      message: 'Payment fail.',
			      type: 'error',
			      showClose: true,
			      customClass: 'custom-message',
			    });
			    return;
	    	}

		    window.location.href = res.data.pay_url;
	    }
	    catch(err) {
	    	loading.close();
	    	this.$message({
		      message: 'Payment fail.',
		      type: 'error',
		      showClose: true,
		      customClass: 'custom-message',
		    });
	    }
  	},

  	async payByUsdt(item) {
  		const loading = Loading.service({
	      fullscreen: true,
	      customClass: 'text-loading',
	      text: 'Payment connecting...'
	    });
	    const userToken = this.userToken || '';

	    try {
	    	const res = await createOrder({
	    		token: userToken,
	    		id: item.id
	    	});

	    	loading.close();
	    	window.location.href = res.data.payUrl;
	    }
	    catch(err) {

	    }
  	},

  	async giveUpInstall() {
  		const userToken = this.userToken || '';

  		this.$refs.installAppTips.hide();
  		report({
	      event_type: 'click',
	      event_value: `click_pay_giveup`
	    });
  	},

  	clickInstallAppTipsButton(item) {
  		if (item.id === 'notnow') {
				this.giveUpInstall();
			}

			if (item.id === 'download') {
				this.gotoDownLoad();
				this.$refs.installAppTips.hide();
			}
  	},

  	async gotoDownLoad() {
			const inviteCode = this.inviteCode || '';
			const userToken = this.userToken || '';

			report({
	      event_type: 'click',
	      event_value: `recharge_to_download`
	    });
    	this.$router.push({
        path: `/download`,
        query: {
        	invite_code: inviteCode,
        }
      });
		},

  	makeRenderList(srcList) {
  		return srcList.map((item) => {
  			return {
  				id: item.package_id,
  				diamonds: item.gems,
  				price: item.price,
  				extra: `${item.extra}%`,
  				type: this.payType
  			}
  		});
  	}
  },

  mounted() {
  	this.init();
  	report({
      event_type: 'view',
      event_value: 'recharge_page'
    });
  },

	components: {
		Navigation,
		AreaLoading,
		Dialog,
		OpenApp,
		Tab
	}
};